module.exports = __webpack_public_path__ + "static/media/zett.64bf3cbc.svg";